import { Component, OnInit, ViewChild, TemplateRef, Input, ChangeDetectorRef } from '@angular/core';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpGridColumn, IEpComponentEventArg, IEpNumericBoxModel } from '@epicor/kinetic';
import { EpbtFaLabelsService } from '../../services/epbt-fa-labels.service';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';
declare var $: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-label-selected-products-grid',
  templateUrl: './epbt-fa-label-selected-products-grid.component.html',
  styleUrls: ['./epbt-fa-label-selected-products-grid.component.scss']
})
export class EpbtFaLabelSelectedProductsGridComponent implements OnInit {

  currency: any;
  public labelsGridModel: IEpGridModel;
  // @Input() deleteFlag: boolean = false;
  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('removeTemplate', { static: true }) removeTemplate: TemplateRef<any>;

  constructor(private labelsService: EpbtFaLabelsService, public epEvent: EpEventService, private _changeDetectionRef: ChangeDetectorRef, ) { }

  ngOnInit() {
    this.currency = this.labelsService.currency;
    this.labelsGridModel = this.getSelectedLabelsGridModel();
    this.updateSelectedLabelsGridData();
  }


  getSelectedLabelsGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'productId', title: '', width: 30, hidden: true },
        { field: 'productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'standardSellPrice', title: 'SELL PRICE', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { title: 'DELETE', width: 30, hidden: false, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToLabelTemplates();
        }
      },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // grid height calculation start
  updateGrid() {
    const calHeight = this.getHeight();
    this.labelsGridModel.height = calHeight;
  }

  getHeight(): number {
    // let heightVal: number;
    // if (!this.deleteFlag) {
    //   heightVal = 580;
    // }
    // else {
    //   heightVal = 350;
    // }
    const height = $(window).outerHeight() - 350; // 399
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    return height;
  }

  updateSelectedLabelsGridData() {
    if (this.labelsService.labelsRequest.products && this.labelsService.labelsRequest.products.length > 0) {
      this.labelsGridModel.data = this.labelsService.labelsRequest.products.slice();
      this.labelsService.productsCount = this.labelsService.labelsRequest.products.length;
    } else {
      this.labelsService.labelsRequest.products = [];
      this.labelsService.productsCount = 0;
      this.labelsGridModel.data = null;
    }
  }

  onRemove(dataItem: any) {
    const index = this.labelsService.labelsRequest.products.findIndex(c => c.productId == dataItem.productId);
    if (index >= 0) {
      this.labelsService.labelsRequest.products.splice(index, 1);
      this.labelsGridModel.data = this.labelsService.labelsRequest.products.slice();
      this.labelsService.productsCount = this.labelsService.labelsRequest.products.length;
    }
  }

  navigateToLabelTemplates() {
    if (!this.labelsService.fromDashboard) {
      this.labelsService.isMoreProducts = true;
    }
    // this._changeDetectionRef.detectChanges();
    // Delay in creating the instace of component,so we are using Timeout
    setTimeout(() => {
      this.epEvent.broadcast(CustomEvents.LabelTemplatesSummaryClick, 1);
    }, 100);
  }

  onCardClick(model) {
    this.navigateToLabelTemplates();
  }

}
